var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRupiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#EBFCEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.303 8.12C11.173 8.63133 10.913 9.043 10.523 9.355C10.133 9.65833 9.704 9.875 9.236 10.005L12.343 14.1H10.705L8.404 11.045C8.15267 10.707 7.949 10.4643 7.793 10.317C7.64567 10.161 7.45933 10.083 7.234 10.083V9.134H8.001C8.46033 9.134 8.846 9.056 9.158 8.9C9.47867 8.73533 9.69967 8.47533 9.821 8.12H7L7.39 7.015H9.847C9.77767 6.73767 9.63467 6.521 9.418 6.365C9.21 6.209 8.924 6.12233 8.56 6.105H7L7.39 5H13.097L12.707 6.105H11.043C11.2077 6.391 11.3073 6.69433 11.342 7.015H13.097L12.707 8.12H11.303Z",
    fill: "#7EC17E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupiIcon);
export default __webpack_public_path__ + "static/media/rupiIcon.9063e13262f49bbdc0dba920de65d95f.svg";
export { ForwardRef as ReactComponent };